import React, { useState, useEffect, useRef } from "react";
import "../styles/Login.css";

const TOKEN_KEY = "@jwtchatnotes";
const POLL_INTERVAL_MS = 2500;
const WHATSAPP_NUMBER = "4915562175400"; // +49 15562 175400 für wa.me ohne +/Leerzeichen
const WHATSAPP_NUMBER_DISPLAY = "+49 15562 175400";

export default function Login({ apiURL, onSuccess }) {
  const baseApiUrl = (apiURL || "https://www.cloud.chatnotes.de").replace(
    /\/$/,
    ""
  );
  const authPath = `${baseApiUrl}/whatsapp/auth.php`;

  const [code, setCode] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const pollRef = useRef(null);

  // Beim Mount: Code anfordern
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetch(`${authPath}?action=request`, {
      method: "GET",
      headers: { Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data.ok && data.code != null && data.session_id) {
          setCode(data.code);
          setSessionId(data.session_id);
        } else {
          setError(data.error || "Code konnte nicht geladen werden.");
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Netzwerkfehler.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [authPath]);

  // Status-Polling sobald session_id da ist
  useEffect(() => {
    if (!sessionId) return;
    const poll = () => {
      fetch(
        `${authPath}?action=status&session_id=${encodeURIComponent(sessionId)}`,
        {
          method: "GET",
          headers: { Accept: "application/json" },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.ok && data.verified && data.token) {
            if (pollRef.current) clearInterval(pollRef.current);
            try {
              localStorage.setItem(TOKEN_KEY, data.token);
            } catch (e) {}
            if (typeof onSuccess === "function") onSuccess(data.token);
          }
        })
        .catch(() => {});
    };
    poll();
    pollRef.current = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [sessionId, authPath, onSuccess]);

  const handleCopy = () => {
    if (!code) return;
    navigator.clipboard
      .writeText(code)
      .then(() => {
        // optional: kurzes Feedback
      })
      .catch(() => {});
  };

  return (
    <div className="login_wrap">
      <div className="login_card">
        <h1 className="login_title">Chatnotes</h1>
        {loading ? (
          <div className="login_loading">Code wird erzeugt…</div>
        ) : error ? (
          <div className="login_error">{error}</div>
        ) : code ? (
          <div className="login_form">
            <div className="login_code_box">
              <div className="login_code_display">{code}</div>
              <button
                type="button"
                className="login_code_copy_btn"
                onClick={handleCopy}>
                Code kopieren
              </button>
            </div>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                code
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="login_btn login_btn_primary">
              Hier klicken um WhatsApp zu öffnen
            </a>
            <p className="login_fallback_hint">
              Sende den Code an {WHATSAPP_NUMBER_DISPLAY} um dich mit Chatnotes
              zu verbinden. Nutze dafür den „Hier klicken um WhatsApp zu
              öffnen“-Button, oder kopiere den Code und sende es manuell.
            </p>
            <p className="login_poll_hint">
              Warte auf deine WhatsApp-Nachricht…
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export { TOKEN_KEY };
